<template>
  <div class='ExportCard'>
    <search-form size='medium'
                 labelWidth='120px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:issueMethod="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, Number(item.issueMethod)) }}</span>
      </template>
      <template v-slot:refundChannel="{ item }">
        <span>{{ refundChannelMap[item.refundChannel] }}</span>
      </template>
      <template v-slot:shop="{ item }">
        <div>{{ item.shop }}</div>
        <div>{{ item.shopCode }}</div>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'

const typeProps = { label: 'name', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      refundChannelMap: {
        1: '线上自助退卡',
        2: '管理端退卡'
      },
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '批次号', prop: 'batchNo', placeholder: '请输入批次号' },
          { type: 'daterange', label: '退卡时间：', prop: 'daterange', span: 12 },
          { type: 'Input', label: '售卡订单号：', prop: 'originalOrderSn', placeholder: '请输入售卡订单号' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: typeProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Input', label: '退卡人会员卡号：', prop: 'memberCardNo', placeholder: '请输入退卡人会员卡号' },
          { type: 'Select', label: '退卡渠道：', prop: 'refundChannel', width: '180px', options:  [
              { name: '线上自助退卡', id: 1 },
              { name: '管理端退卡', id: 2},], props: typeProps, change: row => '', placeholder: '请选择退卡渠道' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ],
        searchHandleSpan: 8
      },

      multipleSelection: [], // 选中的
      Table: { // 表格
        defaultBtn: {
          show: true,
          html: '导出',
          handle: () => this.exportFun()
        },
        data: [],
        column: [
          { prop: 'refundOrderSn', label: '退卡订单号' },
          { prop: 'issueMethod', label: '发行方式', slot: true },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '预付卡号' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'cardCategory', label: '卡种类' },
          { prop: 'denomination', label: '面值' },
          { prop: 'refundTime', label: '退卡时间' },
          { prop: 'refunder', label: '退卡人' },
          { prop: 'originalOrderSn', label: '售卡订单号' },
          { prop: 'refundChannel', label: '退卡渠道', slot: true },
        ]
      }
    }
  },
  created(){
    this.getItemList()
    this.getCardTypeList()
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {

    searchHandleForm () {
      this.getItemList()
    },

    searchResetForm () {
      this.search.searchData = {}
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            // this.asyncData.cardTypeList = res.data
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('卡类型')) {
                item.options = res.data
              }
            })
          }
        })
    },
    // 列表
    getItemList () {
      const { pager, Table } = this
      const params = this.setParams()
      this.$http.refundDetailListApi(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 导出
    exportFun () {
      const params = this.setParams()
      this.$http.refundDetailExportApi(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    setParams () {
      const { batchNo, daterange, originalOrderSn, cardTypeId, memberCardNo, refundChannel } = this.search.searchData
      const { pager } = this
      let params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        batchNo,
        originalOrderSn,
        cardTypeId,
        memberCardNo,
        refundChannel,
        refundStatus: 2
      }
      if (daterange && daterange.length) {
        params.refundStartTime =  daterange[0]
        params.refundEndTime = daterange[1]
      }
      return params
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
